export default "__VITE_ASSET__OYkWyT2c__"